import React from "react";
import { Sparkles } from "lucide-react";

const Hero = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Softer background gradients */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-[-140px] right-[-140px] w-[420px] h-[420px] bg-blue-700/10 rounded-full blur-[110px]" />
        <div className="absolute bottom-[-160px] left-[-140px] w-[420px] h-[420px] bg-[#C9A96A]/[0.06] rounded-full blur-[120px]" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-6 sm:pb-8 text-center">
        {/* Slim badge */}
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#C9A96A]/[0.06] border border-[#C9A96A]/20 text-[#D4B98A] text-[11px] sm:text-xs mb-7 font-medium tracking-wide">
          <Sparkles className="w-3 h-3" />
          <span>حاسبة عجلات COD Mobile</span>
        </div>

        {/* Refined title */}
        <h1
          className="font-black leading-[1.05] tracking-tight text-[2rem] sm:text-[3rem] md:text-[3.5rem]"
          style={{ fontFamily: "'Alexandria', 'Tajawal', sans-serif" }}
        >
          <span className="block text-[#F5F1E8]">احسب تكلفة</span>
          <span className="relative inline-block mt-1.5">
            {/* Very subtle soft glow behind the highlighted word only */}
            <span
              className="absolute inset-0 blur-2xl opacity-40 -z-10"
              style={{
                background:
                  "radial-gradient(closest-side, rgba(201,169,106,0.35), transparent 70%)",
              }}
              aria-hidden="true"
            />
            <span
              className="bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(100deg, #B08A4A 0%, #E5CB94 45%, #D4B278 60%, #B08A4A 100%)",
              }}
            >
              العجلة
            </span>
          </span>
        </h1>

        {/* Description */}
        <p
          className="mt-6 text-slate-400/90 text-sm sm:text-base max-w-xl mx-auto leading-relaxed"
          style={{ fontFamily: "'Alexandria', 'Tajawal', sans-serif" }}
        >
          أدخل نوع الحساب، عدد السحبات، ورصيد CP الحالي لمعرفة تكلفة إكمال العجلة.
        </p>
      </div>
    </section>
  );
};

export default Hero;
